import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectCategoryModel } from '../models/project-category.model';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectCategoryService {
  private configUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'projectcategory';
    });
  }

  public GetProjectCategories(): Observable<ProjectCategoryModel[]> {
    return this.http.get<ProjectCategoryModel[]>(`${this.configUrl}/GetProjectCategories`);
  }
}
